var _defs, _rect, _path;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconFeedbackDone = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}.b{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-2689-213.867a1.02,1.02,0,0,1-.7-.28.987.987,0,0,1-.306-.722V-229a4.005,4.005,0,0,1,4-4h12a4,4,0,0,1,4,4v8a4,4,0,0,1-4,4h-10l-4.445,2.964A.993.993,0,0,1-2689-213.867Zm7.032-14.708a2.4,2.4,0,0,0-1.707.707,2.4,2.4,0,0,0-.707,1.707,2.4,2.4,0,0,0,.707,1.707l3,3a1.007,1.007,0,0,0,.708.293,1.006,1.006,0,0,0,.707-.293l3-3a2.4,2.4,0,0,0,.707-1.707,2.4,2.4,0,0,0-.707-1.707,2.4,2.4,0,0,0-1.707-.707,2.4,2.4,0,0,0-1.707.707l-.292.292-.293-.292A2.4,2.4,0,0,0-2681.965-228.575Z",
    transform: "translate(2692 235)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFeedbackDone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-feedback-done.de1b1ab5.svg";
export { ForwardRef as ReactComponent };